/*
 * Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

import React from "react";
import { Button, TableCell, Card, CardContent, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { ListRenderer } from "../../components/ListRenderer/ListRenderer";
import Link from "@material-ui/core/Link";
import { REPLAY_SUMMARY_FORM } from "../../common/Constants";
import _ from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from '@material-ui/icons/GetApp';
import ReactPlayer from "react-player";

export const ReplayList = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleClipPreview = async (row) => {
    navigate("/clipPreview", {
      state: {
        back: {
          name: "Replay List",
          link: "/listReplays",
        },
        data: row,
        mode: "ReplayClips",
      },
    });
  };

  const handleDownload = async (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'video.mp4'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const getRow = (row) => {
    return [
      <TableCell align="left" style={{width: 450}}>
        { (row.PreviewVideoUrl)?
        <>
            <ReactPlayer
                url={row.PreviewVideoUrl}
                width="100%"
                height="100%"
                controls
                playsinline
                style={{ objectFit: 'cover' }}
            />

        </>
            :<Card style={{ height: "100%", width: "100%", padding: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <CardContent style={{ padding: 60, textAlign: 'center' }}>
                    <Typography variant="caption">No Video Available</Typography>
                </CardContent>
            </Card>
            
        }
      </TableCell>,
      <TableCell align="left">
        {/* <Button
          color={"primary"}
          onClick={() => handleClipPreview(row)}
        >
          <span style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            // maxWidth:'10rem',
            textAlign:'left'
          }}> */}
        {row?.Event}
        {/* </span>
        </Button> */}
        
      </TableCell>,
      <TableCell align="left">{row?.Description}</TableCell>,
      <TableCell align="left">{row?.CatchUp && <CheckIcon />}</TableCell>,
      <TableCell align="left">{row?.Status}</TableCell>,
      <TableCell align="center">
        <IconButton 
              onClick={() => {
                  
                  const filename = row.Description? `${row.Description}.mp4`: 'video.mp4' 
                  handleDownload(row.PreviewVideoUrl, filename);
              }}
              aria-label="download" 
          >
            <GetAppIcon  /> 
        </IconButton>
      </TableCell>
    ];
  };

  return (
    <ListRenderer
      fetchPath={"replay/all"}
      getRow={getRow}
      eventFilterInitValue={_.get(state, "eventFilter")}
      programFilterInitValue={_.get(state, "programFilter")}
      createLink={"/addReplay"}
      header={{
        title: "Recap List",
        addTooltip: "Add new Recap",
        contentGroupFilter: false,
        replayFilter: true,
      }}
      tableHeaders={[
        <TableCell align="center">Thumbnail</TableCell>,
        <TableCell align="left">Event Name</TableCell>,
        <TableCell align="left">Description</TableCell>,
        // <TableCell align="left" style={{ maxWidth: 100 }}>
        //   Duration (Secs)
        // </TableCell>,
        <TableCell align="left">Catch-up</TableCell>,
        <TableCell align="left">Status</TableCell>,
        <TableCell align="center">Action</TableCell>
        // <TableCell align="left">Actions</TableCell>,
      ]}
      emptyTableMessage={
        <>
          You don't have any Recaps created yet.{" "}
        </>
      }
      rows={{
        actions: false
      }}
      // rows={{
      //   actions: {
      //     viewDetails: {
      //       path: "/viewReplay",
      //       name: "Replay List",
      //       link: "/listReplays",
      //       tooltip: "View Replay",
      //       replayDetails: `replay/program/#Program/event/#Event/replayid/#ReplayId`, //replace #Program with row.Program, #Event with row.Event and #ReplayId with row.ReplayId in Child
      //       inputFieldsMap: REPLAY_SUMMARY_FORM,
      //     },
      //   //   clipPreview: {
      //   //     path: "/clipPreview",
      //   //     name: "Replay List",
      //   //     link: "/listReplays",
      //   //   },
      //     Edl: {
      //       path: `event/#Event/program/#Program`, //replace #Name and #Program with row.Name and row.Program in child,
      //       tooltip: "Export to EDL",
      //       showAudioTrackDialog: false,
      //     },
      //     Hls: {
      //       path: `replay/program/#Program/event/#Event/hls/replaymanifest/replayid/#ReplayId`,
      //       showAudioTrackDialog: false,
      //       tooltip: "Export to HLS",
      //     },
      //     downloadMetadata: {
      //       tooltip: "Download Replay data",
      //       path: `replay/export/data/#ReplayId/event/#Event/program/#Program`,
      //       showAudioTrackDialog: false,
      //     },
      //   },
      // }}
    />
  );
};
